import { NgModule } from "@angular/core";

import { SessionHandlerService, SessionHandlerServiceToken } from "./service/session-handler.service";
import { SessionHandlerServiceImpl } from "./service/session-handler.service.impl";
import { SessionManagerService, SessionManagerServiceToken } from "./service/session-manager.service";
import { SessionManagerServiceImpl } from "./service/session-manager.service.impl";
import {
    SessionManagerServiceConfig,
    SessionManagerServiceConfigToken
} from "./model/session-manager.service.config.model";
import { sessionReducer } from "./reducer/session.common.reducer";
import {
    SESSION_FATAL_ERROR,
    SESSION_RESET,
    SESSION_REVIVE_RESET,
    SESSION_TICK,
    SESSION_WARNING_TIMEOUT_SET,
    SessionActionFactory,
    SessionActionFactoryToken
} from "./action/session.action.factory";
import { SessionActionFactoryImpl } from "./action/session.action.factory.impl";
import {
    RECEIVE_SESSION_REVIVE,
    REQUEST_SESSION_REVIVE,
    SessionCommonActionFactory,
    SessionCommonActionFactoryToken
} from "./action/session.common.action.factory";
import { SessionCommonActionFactoryImpl } from "./action/session.common.action.factory.impl";
import { selectSessionState, SESSION_COMMON_STATE_NAME, SessionState } from "./model/session.state.model";
import { ResourceModule } from "../resource/resource.module";
import { CommonModule } from "@angular/common";
import { SessionUserListenerDirective } from "./directive/session-user-listener.directive";
import { SessionTimeoutWarningComponent } from "./component/session-timeout-warning.component";
import {
    SessionTimeoutWarningConfig,
    SessionTimeoutWarningConfigToken
} from "./model/session-tineout-warning.config.model";
import { StoreModule } from "@ngrx/store";
import { MatButtonModule } from "@angular/material/button";
import { SessionTimeoutInfoComponent } from "@feature_core/session/component/session-timeout-info.component";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
    imports: [
        CommonModule,
        ResourceModule,
        MatIconModule,
        MatButtonModule,
        StoreModule.forFeature(SESSION_COMMON_STATE_NAME, sessionReducer)
    ],
    declarations: [
        SessionTimeoutWarningComponent,
        SessionTimeoutInfoComponent,
        SessionUserListenerDirective
    ],
    exports: [
        SessionTimeoutWarningComponent,
        SessionTimeoutInfoComponent,
        SessionUserListenerDirective
    ],
    providers: [
        {provide: SessionHandlerServiceToken, useClass: SessionHandlerServiceImpl},
        {provide: SessionManagerServiceToken, useClass: SessionManagerServiceImpl},
        {provide: SessionActionFactoryToken, useClass: SessionActionFactoryImpl},
        {provide: SessionCommonActionFactoryToken, useClass: SessionCommonActionFactoryImpl}
    ]
})
class SessionModule {
}

export {
    SessionHandlerService,
    SessionHandlerServiceImpl,
    SessionHandlerServiceToken,
    SessionManagerService,
    SessionManagerServiceConfig,
    SessionManagerServiceConfigToken,
    SessionManagerServiceImpl,
    SessionManagerServiceToken,
    RECEIVE_SESSION_REVIVE,
    REQUEST_SESSION_REVIVE,
    SESSION_COMMON_STATE_NAME,
    SESSION_FATAL_ERROR,
    SESSION_TICK,
    SESSION_WARNING_TIMEOUT_SET,
    SessionActionFactory,
    SessionActionFactoryToken,
    SessionActionFactoryImpl,
    SessionCommonActionFactory,
    SessionCommonActionFactoryToken,
    SessionCommonActionFactoryImpl,
    SESSION_RESET,
    SESSION_REVIVE_RESET,
    SessionState,
    SessionTimeoutWarningConfig,
    SessionTimeoutWarningConfigToken,
    SessionTimeoutWarningComponent,
    SessionUserListenerDirective,
    SessionModule,
    selectSessionState
};
